import { IConfig } from '@cian/config/shared';
import { MARKETING_AGREEMENT_LINK, MARKETING_CONFIG_KEY } from '../../../../constants/links';
import { IAgreementConfig } from '../../../../thunks/legalAgreement/sendLegalAgreements';

export const getMarketingAgreementUrl = (config: IConfig): string => {
  const marketingConfig = config.getStrict<IAgreementConfig>(MARKETING_CONFIG_KEY);

  return marketingConfig?.agreement ?? MARKETING_AGREEMENT_LINK;
};
